<template>
  <div class="toast">
    <el-dialog :visible.sync="isshow" :modal-append-to-body="false" @close="changeStatus">
      <div slot="title" class="jumFpeedback_head">
        <img src="/img/logo.e85e07f3.png" alt="" />
        <b></b>
        <span>忘记密码</span>
      </div>
      <div class="jumpFeedback_body">
        <div class="user">
          <input
            type="text"
            v-model="phone"
            placeholder="在此输入手机号/邮箱"
            @focus="focusFn"
            @input="changeFn"
            @blur="blurFn"
          />
          <img v-show="status.delIsShow" src="/img/del.3e24f5a3.png" alt="" @click="delBtn" />
        </div>
        <div class="code">
          <el-input v-model="code" placeholder="请输入验证码" />
          <el-button type="primary" @click="btnTimeFn">
            {{ isClickBtn ? `重新发送${time}s` : '获取验证码' }}
          </el-button>
        </div>
        <div class="inputSty">
          <el-input type="password" v-model="password" placeholder="设置密码" />
        </div>
        <div class="inputSty">
          <el-input type="password" v-model="confirmPassword" placeholder="再次输入密码" @blur="blurPwdFn" />
        </div>
        <div class="loginBtn active" @click="registerFn">
          <span>保存</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ForgetPwd',
  data() {
    return {
      phone: '',
      code: '',
      password: '',
      confirmPassword: '',
      isClickBtn: false,
      time: 59,
      status: { styleStatus: false, delIsShow: false },
      isshow: false
    }
  },
  props: {
    state: { type: Boolean, default: false },
    isClose: { type: Function, default() {} }
  },
  watch: {
    state() { this.isshow = this.state }
  },
  methods: {
    changeStatus() { this.isClose(true) },
    focusFn() { this.status.styleStatus = true },
    blurFn() {
      this.status.styleStatus = false
      this.status.delIsShow = false
      if (this.phone) this.status.delIsShow = true
    },
    changeFn() { this.status.delIsShow = !!this.phone },
    delBtn() { this.phone = ''; this.status.delIsShow = false },
    btnTimeFn() {
      if (this.isClickBtn) return
      this.isClickBtn = true
      const phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/
      const emailReg = /^[A-Za-z0-9_一-龥]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (this.phone && (phoneReg.test(this.phone) || emailReg.test(this.phone))) {
        const timer = setInterval(() => {
          this.time--
          if (this.time === 0) { clearInterval(timer); this.time = 59; this.isClickBtn = false }
        }, 1000)
        axios({ method: 'post', url: '/realNet/customer/sendSms', data: { phoneNumOrEmail: this.phone } })
      } else {
        this.isClickBtn = false
        this.$message({ showClose: true, message: '请先输入手机号或邮箱', type: 'warning', duration: 1000 })
      }
    },
    blurPwdFn() {
      if (this.password !== this.confirmPassword) {
        this.$message({ showClose: true, message: '请确保两次密码一致!', type: 'warning', duration: 1000 })
      }
    },
    registerFn() {
      if (this.phone && this.code && this.password && this.password === this.confirmPassword) {
        const data = { firstCode: this.code, phoneNumOrEmail: this.phone, password: this.password }
        axios({ method: 'put', url: '/realNet/customer/forgetPassword', data }).then(res => {
          if (res.data.code == 200) {
            this.$message({
              showClose: true, message: '重新设置密码成功!', type: 'success', duration: 1000,
              onClose: () => { this.$emit('resign', { phone: this.phone, pwd: this.password }) }
            })
            this.isshow = false
          } else {
            this.$message({ showClose: true, message: res.data.message, type: 'warning', duration: 1000 })
          }
        })
      } else if (!this.phone) {
        this.$message({ showClose: true, message: '请先输入手机号或邮箱', type: 'warning', duration: 1000 })
      } else if (!this.code) {
        this.$message({ showClose: true, message: '请先输入验证码', type: 'warning', duration: 1000 })
      } else {
        this.$message({ showClose: true, message: '两次密码输入不一致', type: 'warning', duration: 1000 })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toast {
  ::v-deep .el-dialog {
    width: 480px;
    border-radius: 8px;
  }

  ::v-deep .el-dialog__header {
    width: 100%;
    box-sizing: border-box;
  }

  ::v-deep .el-dialog__body,
  ::v-deep .el-dialog__footer {
    padding: 0;
  }

  .jumFpeedback_head {
    display: flex;
    align-items: center;

    img { margin-top: 0; }

    b {
      width: 4px;
      height: 4px;
      margin: 0 10px;
      background-color: #3bc0d0;
      border-radius: 50%;
      display: inline-block;
    }

    span {
      font-size: 18px;
      color: #3bc0d0;
    }
  }

  .jumpFeedback_body {
    width: 100%;
    padding: 40px 61px 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: column;

    .user {
      width: 100%;
      height: 55px;
      margin-bottom: 20px;
      border-bottom: 1px solid #e1e9eb;
      display: flex;
      align-items: center;

      input {
        width: 90%;
        height: 30px;
        border: none;
        outline: none;
        font-size: 16px;

        &::placeholder { color: #ccc; }
      }

      img { cursor: pointer; }
    }

    .code {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .inputSty {
      width: 100%;
      height: 55px;
      margin-bottom: 20px;
      border-bottom: 1px solid #e1e9eb;
      display: flex;
      align-items: center;
    }

    .loginBtn {
      width: 360px;
      height: 50px;
      margin-top: 20px;
      background-color: #3bc0d0;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        font-size: 18px;
        color: #fff;
        letter-spacing: 1px;
      }
    }
  }

  .active {
    border-bottom: 1px solid #3bc0d0 !important;
  }
}
</style>
